// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__uiTUs","label":"Radio_label__14IDR","checkMark":"Radio_checkMark__1hA56","disabled":"Radio_disabled__2KIe0"};